import { create, AxiosInstance } from 'axios';
import { getHostBaseUrl } from 'utils/browserUtil';

export const axiosInstance: AxiosInstance = create({
  baseURL: getHostBaseUrl(),
  withCredentials: true,
});
